import { useMemo, useState } from 'react';

import cs from 'classnames';

import { iaRa } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import Popover from 'components/shared/Popovers/Popover/Popover';

const CategoryPicker = ({ file, categories, onCategoryChange }) => {
  const [search, setSearch] = useState('');

  const selectedCategory = categories.find((category, idx) =>
    file.category ? category.value === file.category : idx === 0
  );

  const filteredCategories = useMemo(
    () => iaRa(categories).filter((cat) => cat.label.toLowerCase().includes(search.toLowerCase())),
    [categories, search]
  );

  return (
    <Popover
      icon="context-menu-horizontal"
      position="left"
      isFixed
      isBorder={false}
      customButtonTrigger={
        <div className="group flex h-6 w-auto cursor-pointer items-center justify-center gap-x-1 whitespace-nowrap">
          <p className="whitespace-nowrap text-xs font-medium leading-[14px]">
            <span className="text-neutral-500">Category:</span>
            <span className="text-neutral-900">{` ${selectedCategory?.label || ''}`}</span>
          </p>
          <Icon
            size={16}
            icon="chevron-down-linear"
            color="neutral"
            shade={700}
            className="shrink-0"
          />
        </div>
      }
      panelClassName="!gap-0 !p-0 !py-0 !w-[360px] !max-h-[320px] !overflow-hidden !rounded !shadow-[0px_0px_16px_0px_rgba(65,70,81,0.08)] !border !border-neutral-300 !border-solid">
      {({ closePopover }) => (
        <div className="flex flex-col">
          <Input
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon="search-linear"
            inputWrapperClassName="!rounded-none !border-x-0 !border-t-0 !border-b !border-neutral-200 !outline-none !h-10 !pl-4 !pr-2"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="max-h-[264px] overflow-y-auto">
            <div className="flex flex-col gap-1 py-2">
              {iaRa(filteredCategories).map((category) => (
                <div
                  key={category.value}
                  className={cs(
                    'flex h-8 cursor-pointer items-center px-4 text-sm font-normal text-neutral-900',
                    'hover:bg-neutral-50',
                    selectedCategory?.value === category.value && '!bg-neutral-75'
                  )}
                  onClick={() => {
                    onCategoryChange(file.fileId, category.value);
                    closePopover();
                  }}>
                  <span className="overflow-hidden text-ellipsis whitespace-nowrap leading-[17px]">
                    {category.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Popover>
  );
};

export default CategoryPicker;
